import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYamahamotorcorporationComponent } from './simple-icons-yamahamotorcorporation.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYamahamotorcorporationComponent ],
    exports:      [ SimpleIconsYamahamotorcorporationComponent ],
    bootstrap:    []
})
export class SimpleIconsYamahamotorcorporationModule {}
